<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import UseSvg from "components/jiffy/vue-cart/UseSvg.vue";

const store = useStore();
const status = computed(() => store.getters["loading/uploadArtworkStatus"]);
</script>

<template>
  <div class="artwork-loading-message">
    <UseSvg class="artwork-loading-message__icon" icon="upload-cloud" type="print" />

    <div class="artwork-loading-message__body-wrapper">
      <div class="artwork-loading-message__title">{{ status.title }}</div>

      <div class="artwork-loading-message__text">{{ status.message }}</div>
    </div>
  </div>
</template>

<style scoped lang="scss">
@import "frontend/init/pod/settings";

.artwork-loading-message {
  display: flex;
  align-items: center;

  &__icon {
    width: 28px;
    height: 28px;
    flex: none;
    margin-right: 5px;
  }

  &__body-wrapper {
    flex: 1;
  }

  &__title {
    font-size: 15px;
    font-weight: 500;
    line-height: 1;
    margin-bottom: 5px;
  }

  &__text {
    font-size: 10px;
    line-height: 1;
  }
}
</style>
